import request from '@/utils/request'

// 查询标准路径节点配置列表
export function listStandardTemplateNodeUser(query) {
    return request({
        url: '/biz/standardTemplateNodeUser/list',
        method: 'get',
        params: query
    })
}
export function listSearchStandardTemplateNodeUser(query) {
    return request({
        url: '/biz/standardTemplateNodeUser/listSearch',
        method: 'get',
        params: query
    })
}

// 查询标准路径节点配置详细
export function getStandardTemplateNodeUser(id) {
    return request({
        url: '/biz/standardTemplateNodeUser/' + id,
        method: 'get'
    })
}

// 新增标准路径节点配置
export function addStandardTemplateNodeUser(data) {
    return request({
        url: '/biz/standardTemplateNodeUser',
        method: 'post',
        data: data
    })
}

// 修改标准路径节点配置
export function updateStandardTemplateNodeUser(data) {
    return request({
        url: '/biz/standardTemplateNodeUser/update',
        method: 'post',
        data: data
    })
}

// 删除标准路径节点配置
export function delStandardTemplateNodeUser(id) {
    return request({
        url: '/biz/standardTemplateNodeUser/delete/' + id,
        method: 'post'
    })
}
